module.exports = __webpack_public_path__ + "static/steel-section-df88763410277252ee1d473e652db0c9.png";